import { render, staticRenderFns } from "./TournamentsList.vue?vue&type=template&id=9a28d9b8"
import script from "./TournamentsList.vue?vue&type=script&lang=js"
export * from "./TournamentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports